/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import TizetiLoader from '../../../../../assets/img/icons/TizetiLoaderColored.gif';
import { useExtensions } from '../../../../../actions/shared/customers/extensions/CustomersExtensionsActions';
import axios from 'axios';
import CustomCsvDownload from '../../CustomCsvDownload';

const Extensions = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [macId, setMacId] = useState('');
  const [isSearching, setIsSearching] = useState(false); // To separate search vs default fetch
  const [filteredResults, setFilteredResults] = useState([]);
  const [downloadData, setDownloadData] = useState([]);
  const [isPreparingDownload, setIsPreparingDownload] = useState(false);


  const {
    extensions,
    setExtensions,
    loading,
    error,
    page,
    setPage,
    getExtensions,
    paginateExtensions,
  } = useExtensions();

  // Load default data on mount (page 1)
  useEffect(() => {
    getExtensions(1);
  }, []);

  // Handles POST request for filtered search
  const fetchData = async (pageNumber = 1) => {
    setIsSearching(true);
    setPage(pageNumber);
    setDownloadData([]);

    const requestBody = {};
    if (macId) requestBody.macid = macId;
    if (fromDate && toDate) {
      requestBody.from = fromDate;
      requestBody.to = toDate;
    }

    try {
      const response = await axios.post(
        `https://api.tizeti.com/api/v1/geniatechlog/get_extension_logs/${pageNumber}`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        }
      );

      // if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

      //const result = await response.json();
      setExtensions(response.data); // Set to hook's state
      const searchCriteria = macId || (fromDate && toDate)
      setFilteredResults(searchCriteria ? response.data.logs || [] : []);
    } catch (err) {
      console.error('Error fetching search data:',err.message);
    } finally {
      setIsSearching(false);
    }
  };

  const fetchAllPages = async () => {
  let allResults = [];
  let pageNumber = 1;
  let hasMore = true;

  while (hasMore) {
    try {
      const requestBody = {};
      if (macId) requestBody.macid = macId;
      if (fromDate && toDate) {
        requestBody.from = fromDate;
        requestBody.to = toDate;
      }

      const response = await axios.post(
        `https://api.tizeti.com/api/v1/geniatechlog/get_extension_logs/${pageNumber}`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data.logs && response.data.logs.length > 0) {
        allResults = [...allResults, ...response.data.logs];
        pageNumber++;
        if (pageNumber > response.data.pages) {
          hasMore = false;
        }
      } else {
        hasMore = false;
      }
    } catch (err) {
      console.error('Error fetching all pages:', err.message);
      hasMore = false;
    }
  }

  return allResults;
};

  // Form submission
  const onSubmit = (e) => {
    e.preventDefault();
    setDownloadData([]); 
    setFilteredResults([]); 
    fetchData(1); 
  };

  // Pagination handler
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1;
    setPage(selectedPage);
    if (macId || (fromDate && toDate)) {
      fetchData(selectedPage);
    } else {
      paginateExtensions(selectedPage);
    }
  };

  const prepareCsvData = (data) => {
    if (!data || data.length === 0) return [];
    return data.map((extension, i) => ({
      index: i + 1,
      employee: extension.EmployeeAuth && extension.EmployeeAuth.employees && extension.EmployeeAuth.employees[0] 
      ? `${extension.EmployeeAuth.employees[0].firstName} ${extension.EmployeeAuth.employees[0].lastName}`
      : 'N/A',
      daysExtended: extension.extending_days,
      MacId: extension.macid,
      name: extension.name,
      Reason: extension.comment,
      date: moment(extension.created_at).format('YYYY-MM-DD')
    })) || [];
  }

  const handleDownload = async () => {
  setIsPreparingDownload(true);
  try {
    const allData = await fetchAllPages();
    const csvData = prepareCsvData(allData);
    setDownloadData(csvData);
  } catch (err) {
    console.error('Error preparing download:', err);
    setDownloadData([]);
  } finally {
    setIsPreparingDownload(false);
  }
};

  const csvHeaders = [
    { label: '#', key: 'index' },
    { label: 'Employee', key: 'employee' },
    { label: 'Days Extended', key: 'daysExtended' },
    { label: 'Customer Mac ID', key: 'MacId' },
    { label: 'Customer Name', key: 'name' },
    { label: 'Reason for Extension', key: 'Reason' },
    { label: 'Date of Extension', key: 'date' }
  ];

  const { logs = [], pages = 0 } = extensions;

  const extensionLists = logs ? (
    logs.map((extension, i) => (
      <tr key={i + 1}>
        <td>{i + 1}</td>
        {extension.EmployeeAuth && extension.EmployeeAuth.employees[0] ? (
          <td>
            {extension.EmployeeAuth.employees[0].firstName} {extension.EmployeeAuth.employees[0].lastName}
          </td>
        ) : (
          'N/A'
        )}
        <td>{extension.extending_days}</td>
        <td>{extension.macid}</td>
        {extension.name ? <td>{extension.name}</td> : <td>N/A</td>}
        <td>{extension.comment}</td>
        <td>{moment(extension.created_at).format('YYYY-MM-DD')}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td>
        <p>There are no extensions</p>
      </td>
    </tr>
  );

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 mt-5">
          <div className="card x-panel">
            <form onSubmit={onSubmit} className="row align-items-end g-4">
              <div className="col-md-4">
                <label>MAC ID:</label>
                <input
                  type="text"
                  className="form-control"
                  value={macId}
                  onChange={(e) => setMacId(e.target.value)}
                  placeholder="Enter MAC ID"
                />
              </div>
              <div className="col-md-3">
                <label>From:</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <label>To:</label>
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <div className='col-md-2'>
              <button type="submit" className="btn btn-primary" style={{backgroundColor: '#66bb6a',border: 'none',outline: 'none',}}>
                Search
              </button>
              </div>
              {filteredResults.length > 0 && 
              <div className='col-md-2'> 
              {downloadData.length > 0 ? (
              <CustomCsvDownload
                data={downloadData}
                headers={csvHeaders}
                filename={`Filtered Customer Extensions for ${moment().format('YYYY-MM-DD')}`}
                classname="btn btn-green outline-none border-none"
                textcolor="#ffffff"
                text="Download Results"
              />
              ) : (
                <button 
                  onClick={handleDownload}
                  className="btn btn-green outline-none border-none"
                  style={{ color: '#ffffff' }}
                  disabled={isPreparingDownload}
                >
                  {isPreparingDownload ? "Preparing Download..." : "Prepare Download"}
                </button>
              )}
              </div>}
            </form>

            {error && (
              <div className="alert alert-danger mx-3">Error: {error.message}</div>
            )}

            <div className="table-responsive content">
              <table className="table copy-font">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Employee</th>
                    <th>Days Extended</th>
                    <th>Customer Mac ID</th>
                    <th>Customer Name</th>
                    <th>Reason for Extension</th>
                    <th>Date of Extension</th>
                  </tr>
                </thead>
                <tbody>
                  {loading || isSearching ? (
                    <tr>
                      <td colSpan="7" className="text-center">
                        <img src={TizetiLoader} alt="loader" />
                      </td>
                    </tr>
                  ) : (
                    extensionLists
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {pages > 1 && (
        <ReactPaginate
          breakLabel="..."
          pageCount={pages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName="pagination justify-content-center"
          activeClassName="active"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          nextClassName="page-item"
          previousLinkClassName="page-link"
          nextLinkClassName="page-link"
        />
      )}
    </div>
  );
};

export default Extensions;
